






































import * as _ from 'lodash'
import dayjs from 'dayjs'
import { logColumns, extranetStatusPic } from '../data'
import ConnectionRecord from './ConnectionRecord.vue'
import { ExtranetConfigServiceProxy } from '@/service-proxies/app-v2/iot-extranet.service-proxies'
import { createExtranetVersionService } from './../ExtranetVersionService'
const ecsp = new ExtranetConfigServiceProxy()
export default {
  name: 'ExtranetHeader',
  components: {
    ConnectionRecord
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {
         'name': '2',
          'version': '2',
          'extranetServerAddress': '2',
          'extranetServerStatus': '2',
          'code': '2'
        }
      }
    },
    logs: {
      type: Array,
      default: () => []
    },
    versionService:{
      type: Object,
      default:()=>{
        return createExtranetVersionService()
      }
    },
    extranetService:{
      type: Object,
      default:()=>{
        return undefined;
      }
    },
    disenableRecord:{
      type: Boolean,
      default: ()=> false
    }
    
  },
  data() {
    return {
      logColumns,
      extranetStatusPic, // 诊断状态图
      logstr: '', // 诊断日志列表搜索字段
      extranetLogList: [], // 连接日志
      filterExtranetLogList: [], // 过滤日志
      extranetSocketConfig: null,
      userVirtualIp: null,
      editShow:false,
      logVisible: false
    }
  },
  computed:{
    extranetStatus(){
      return this.extranetService?.serverInfo?.extranetServerStatus;
    }
  },
  mounted(){
  },
  watch: {
    data: {
      handler(data) {
        this.extranetSocketConfig = data
        this.getUser()
      },
      immediate: true
    },
    logs: {
      handler(data) {
        if (data) {
          this.extranetLogList = _.cloneDeep(data)
          this.extranetLogList.map((item, index) => {
            item.key = index
            item.time = dayjs(item.time).format('YYYY-MM-DD HH:mm:ss')
          })
          this.filterExtranetLogList = _.cloneDeep(this.extranetLogList)
        }
      },
      immediate: true
    }
  },
  methods: {
    async getUser() {
      await ecsp.getUserConfig().then(res => {
        this.userVirtualIp = res.userVirtualIp
      })
    },
    handleChange(value) {
     this.userVirtualIp = value
    },
    async check() {
      console.log(this.userVirtualIp);
      const reg = /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/
      if(!this.userVirtualIp) {
        this.$message.error('请输入IP')
        return false
      }else if(!reg.test(this.userVirtualIp)) {
           this.$message.error('IP格式错误')
           return false
      }else {
        await ecsp.saveUserConfig(this.userVirtualIp).then(res => {
          console.log(res);
          this.editShow = false
          this.getUser()
          this.$message.success('修改IP成功')
          
        })
      }
        // await ecsp.saveUserConfig(this.userVirtualIp).then(res => {
        //   console.log(res);
        // })
    },
    // 清空诊断日志
    clearExtranetLogs() {
      this.extranetLogList = []
      this.filterExtranetLogList = []
      this.$emit('clearLogs')
    },
    // 搜索日志
    searchLogs() {
      if (this.logstr) {
        if (this.extranetLogList.length) {
          this.filterExtranetLogList = this.extranetLogList.filter(item =>  item.message.indexOf(this.logstr) > -1)
        } else {
          this.filterExtranetLogList = []
        }
      } else {
        this.filterExtranetLogList = _.cloneDeep(this.extranetLogList)
      }
    },
    onBlur(e){
      console.log('焦点:',e)
    }
  }
}
